import useDeviceSettingsContent from './useDeviceSettingsContent';

const getItemByType = (type, settingsContent) => {
    for (const group of settingsContent) {
        const found = group.items.find((item) => item.type === type);

        if (found) return found;
    }
    return null;
};

const useDeviceSettingContent = (type) => {
    const {settings} = useDeviceSettingsContent();

    const result = getItemByType(type, settings);

    return result;
};

export default useDeviceSettingContent;
